(() => {
  class VgtHeroVideo extends HTMLElement {
    connectedCallback() {
      const v = this.querySelector('video');
      if (!v) return;

      // Hard force autoplay compatibility
      try {
        v.muted = true;
        v.defaultMuted = true;
        v.volume = 0;

        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.setAttribute('autoplay', '');
        v.setAttribute('loop', '');

        v.autoplay = true;
        v.loop = true;

        // Some themes/lazy loaders need this
        v.preload = 'auto';
        v.load();
      } catch (e) {}

      const tryPlay = () => {
        try {
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } catch (e) {}
      };

      // Try immediately + after readiness
      tryPlay();
      const timers = [150, 400, 900, 1600, 2600];
      timers.forEach((t) => setTimeout(tryPlay, t));

      v.addEventListener('loadedmetadata', tryPlay, { once: true });
      v.addEventListener('canplay', tryPlay);
      v.addEventListener('playing', () => {
        // ensure muted stays forced
        v.muted = true;
        v.volume = 0;
      });

      // If browser blocks, play on first interaction
      const kick = () => {
        try {
          v.muted = true;
          v.volume = 0;
          v.play().catch(() => {});
        } catch (e) {}
      };

      window.addEventListener('touchstart', kick, { passive: true, once: true });
      window.addEventListener('pointerdown', kick, { once: true });
      window.addEventListener('click', kick, { once: true });
    }
  }

  if (!customElements.get('vgt-hero-video')) {
    customElements.define('vgt-hero-video', VgtHeroVideo);
  }
})();
